import { Build, Component, Element, h } from '@stencil/core';

@Component({
  tag: 'staedtler-slider-teaser-s',
})
export class SliderTeaserS {
  @Element() el: HTMLElement;
  swiper;

  async componentDidLoad() {
    if (!Build.isBrowser) {
      return;
    }
    if (window.innerWidth < 768) {
      const { initializeSlider } = await import('~service/swiper');
      this.swiper = initializeSlider(this.el, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        slideClass: 'teaser-s',

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }

  render() {
    return (
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <slot />
        </div>
        <div class="swiper-pagination"></div>
      </div>
    );
  }
}
